import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Welcome from './components/Welcome';
import Spaces from './components/Spaces';
import Amenities from './components/Amenities';
import Benefits from './components/Benefits';
import Gallery from './components/Gallery';
import ConferenceRoomPreview from './components/ConferenceRoomPreview';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BrokerCompensation from './components/BrokerCompensation';
import ConferenceRoomPage from './components/ConferenceRoomPage';
import './App.css';

const HomePage = () => (
  <>
    <Hero />
    <Welcome />
    <Spaces />
    <Benefits />
    <Amenities />
    <Gallery />
    <ConferenceRoomPreview />
    <BrokerCompensation />
    <Contact />
  </>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/conference-room" element={<ConferenceRoomPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
